//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
import OverViewIcon from "../Icons/OverViewIcon";
import { Outlet } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { getKey } from "../helpers/sessionKey";
import WelcomeIcon from "../Icons/WelcomeIcon";

export const shouldShowWelcome = getKey("shouldShowWelcome");

export const navigation: any = [
  {
    name: "Dashboard",
    href: "",
    icon: "",
    children: [
      ...(shouldShowWelcome === "true" || shouldShowWelcome === null
        ? [
            {
              name: "Welcome",
              href: "/template",
              icon: WelcomeIcon,
              activeIcon: WelcomeIcon,
            },
            {
              name: "Overview",
              href: "/template/overview",
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]
        : [
            {
              name: "Overview",
              href: "/template",
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]),
    ],
  },
  {
    name: "Layout",
    href: "",
    icon: "",
    children: [
      {
        name: "Template",
        href: "/template/templatelist",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Excel Template",
        href: "/template/exceltemplatelist",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Column Definition",
        href: "/template/columndefinitionlist",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw` p-2 overflow-y-auto h-full`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
